import clsx from "clsx";

// Interface
interface IconProps {
	classes?: string;
	sx?: object;
	disabled?: boolean;
}

// MUI
import { SvgIcon } from "@mui/material";

// Images
import { ReactComponent as Unreviewable } from "@/Washouts/assets/icons/Unreviewable.svg";

export default function UnreviewableIcon(props: Readonly<IconProps>) {
	const { classes = "", sx = null } = props;

	return (
		<SvgIcon
			inheritViewBox
			component={Unreviewable}
			className={clsx({
				[classes]: Boolean(classes),
			})}
			sx={sx}
		/>
	);
}
